import TranslatorServerRepository from '../../repositories/TranslatorServerRepository';
// import Vue from 'vue'

export default {
	namespaced: true,
	state: {

	},
	mutations: {

	},
	actions: {
		fetchAll ({ commit, getters }) {
			return TranslatorServerRepository.all();
		},
		syncAll ({ commit, getters }) {
			return TranslatorServerRepository.syncAll();
		},
		deleteServer ({ commit, getters }, id) {
			return TranslatorServerRepository.deleteServer(id);
		}
	},
	getters: {
	}
};
